// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close{position:absolute;right:1rem}\n", "",{"version":3,"sources":["webpack://./main/frontend/src/assets/css/bootstrap.override.css"],"names":[],"mappings":"AAAA,OACE,iBAAkB,CAClB,UAAW","sourcesContent":[".close {\n  position: absolute;\n  right: 1rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
